<div class="wrapper">
    <div class="text-center content p-3"
         [class.bordered]="isExpanded"
         [class.transparent-border]="!isExpanded"
         [class.grey-section]="!isExpanded">
        <h3 class="small-heading">
            <ng-content select="[heading]"></ng-content>
        </h3>
        <div *ngIf="!isExpanded">
            <div class="row">
                <p class="col-xs-12 col-md-10 col-md-offset-1">
                    <ng-content select="[collapsedPreDescription]"></ng-content>
                </p>
            </div>
            <div class="row">
                <app-selected-preferences [preferredCategories]="originalPreferredCategories"
                                          class="col-xs-12">
                </app-selected-preferences>
            </div>
            <div class="row">
                <p class="col-xs-12 col-md-10 col-md-offset-1">
                    <ng-content select="[collapsedPostDescription]"></ng-content>
                </p>
            </div>
        </div>
        <div *ngIf="isExpanded">
            <p>
                <ng-content select="[expandedPreDescription]"></ng-content>
            </p>
            <app-rating-selector [(preferredCategories)]="changedPreferredCategories"></app-rating-selector>
            <p>
                <ng-content select="[expandedPostDescription]"></ng-content>
            </p>
            <div class="d-flex justify-content-center flex-wrap">
                <button type="button" class="primary m-2" mat-flat-button
                        [disabled]="changedPreferredCategories.length === 0 || shouldDisablePositiveButton()"
                        (click)="onFindLoansClicked(changedPreferredCategories)">
                    <ng-content select="[positiveButtonText]"></ng-content>
                </button>
                <button mat-stroked-button class="primary m-2" style="margin-left: 20px;"
                        (click)="cancel()"
                        *ngIf="!_isAlwaysExpanded">
                    CANCEL
                </button>
            </div>
        </div>
    </div>
</div>